


































import { Component, Prop, Mixins } from 'vue-property-decorator'
  import BaseVue from '@/mixins/BaseVue'
  import { EPromotionStatus, PromotionInput } from '@/services/connecteur'
  import KAMSelect from '@/components/Selects/KAMSelect.vue'
  import DPSelect from '@/components/Selects/DPSelect.vue'
  import KAMAssistantSelect from '@/components/Selects/KAMAssistantSelect.vue'
import userModule from '@/store/modules/UserModule'

  @Component({
    components: {
      KAMSelect,
      DPSelect,
      KAMAssistantSelect
    }
  })
  export default class ContactView extends Mixins(BaseVue) {
    @Prop({ required: true })
    public promotion!: PromotionInput

    @Prop({ default: false })
    public isCreation!: boolean

    @Prop({ default: false })
    public error!: boolean

    public KAM_STATUSES = [
      EPromotionStatus.NEW,
      EPromotionStatus.REWORK,
      EPromotionStatus.PREVALIDATED
    ]

    public DP_STATUSES = [
      EPromotionStatus.DRAFT,
      EPromotionStatus.CHANGED,
      EPromotionStatus.APPROVED,
      EPromotionStatus.CANCELLED
    ]

    public updatePromotion () {
      this.$emit('update:promotion', this.promotion)
    }

    public updateError (newValue: boolean) {
      this.$emit('update:error', newValue)
    }

    public userCanEditContact (includeDP = false) {
      if (!this.promotion.salesOrgId) {
        return false
      }

      if (
        userModule.isKeyUserOnSalesOrg(this.promotion.salesOrgId) &&
        (this.isStatus(this.KAM_STATUSES) || this.isStatus(this.DP_STATUSES))
      ) {
        return true
      }

      if (includeDP) {
        return (
          this.isStatus(this.KAM_STATUSES) || this.isStatus(this.DP_STATUSES)
        )
      } else {
        return this.isStatus(this.KAM_STATUSES)
      }
    }

    public isStatus (
      status: EPromotionStatus | Array<EPromotionStatus>
    ): boolean {
      return Array.isArray(status)
        ? this.promotion.statusId
          ? status.includes(this.promotion.statusId)
          : false
        : status === this.promotion.statusId
    }
  }
